import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import TranslateButton from "../../TranslateButton/TranslateButton";
import "../../../style/jobCircular/jobCircularDYD.css";
import CircularTwo from "../../../images/Job Circular/Circular_Request for DYD_2.jpg";
import CircularThree from "../../../images/Job Circular/Circular_Request for DYD_3.jpg";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const JobCircularDYD = () => {
  useEffect(() => {
    document.title = `Development Concern | Job Circular`;
  }, []);

  // const shareUrl = "https://developmentconcerncht.org/job-circular/earn-project";

  return (
    <>
      <Navbar />
      {/* <TranslateButton /> */}

      <div className="earn_project_section">
        {/* Header Background Part Start */}
        {/* <div className="header_background">
          <div className="container wrapper">
            <h2>Job Circular</h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div> */}
        {/* Header Background Part End */}

        <div className="earn_project_wrapper">
          <div className="container">
            <h2>Job Circular Demo</h2>
            <img src={CircularTwo} alt="" />
            <img src={CircularThree} alt="" />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default JobCircularDYD;
